import React, { Component } from 'react'
// import MenuItems from './MenuItems'
// import Head from './Head.jsx'
import Partners from './Partners.jsx'
// import Team from './Team.jsx'
// import Projects from './Projects.jsx'
import Contacts from './Contacts.jsx'
import ResponsiveContainer from './ResponsiveContainer.jsx'


// import Examples from './Examples.jsx'
import Footer from './Footer.jsx'
import {
  // Button,
  // Container,
  // Divider,
  // Grid,
  // Header,
  // Icon,
  // Image,
  // List,
  // Menu,
  // Segment,
  // Visibility,
} from 'semantic-ui-react'

// const styles = {
//   menuItem: {
//     textTransform: 'uppercase',
//     fontSize: '.95rem',
//     letterSpacing: '.1rem',
//   },
// }

// const FixedMenu = () => (
//   <Menu inverted pointing fixed='top' size='large'  style={styles.menuItem}>
//     <Container>
        

//       <MenuItems />

//     </Container>
//   </Menu>
// )

export default class HomepageLayout extends Component {
  // state = {}

  // hideFixedMenu = () => this.setState({ visible: false })
  // showFixedMenu = () => this.setState({ visible: true })

  render() {
    // const { visible } = this.state

    return (
      <ResponsiveContainer>
        {/* { visible ? <FixedMenu /> : null } */}

        {/* HEAD */}
        {/* <Visibility
          onBottomPassed={this.showFixedMenu}
          onBottomVisible={this.hideFixedMenu}
          once={false}
          >
          <section id='home'>
            <Segment
              inverted
              textAlign='center'
              style={{ minHeight: 760, padding: '1em 0em', background:'center center no-repeat', backgorundSize:'cover', backgroundImage:'url(img/header-bg.jpg)' }}
              vertical
              >
              
              <MenuItems />

              <Head/>

            </Segment>
          </section>
        </Visibility> */}





        <Partners />
        {/* <Projects /> */}
        {/* <Team /> */}


        <Contacts />

        {/* <Examples /> */}

        <Footer />


      </ResponsiveContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.jsx